import axios from 'axios'
import Vue from 'vue'
import hostConfig from './config'
import $language from '../lang'
const baseUrl = hostConfig.apiHost
const apiConfig = axios.create({
    // 设置超时时间
    timeout: 10000,
    // 请求的baseUrl
    baseURL: baseUrl,
    // 请求头部信息
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
    },
    withCredentials: false,
    // 请求参数转换
    transformRequest: [function (data) {
        let ret = ''
        for (let it in data) {
            if (data[it] === 0 || (data[it] || data[it] === '') || data[it] === false) {
                if (ret !== '') ret += '&'
                ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it])
            }
        }
        return ret
    }]
})

// 请求拦截
apiConfig.interceptors.request.use(config => {
    Vue.prototype.$Toast.loading({
        loadingType: 'spinner',
        message: $language.request.loadingText,
        duration: 0
    })
    if (!config.data) {
        config.data = {}
    }
    return config
}, err => {
    return Promise.reject(err)
})

// 响应拦截
apiConfig.interceptors.response.use(res => {
    Vue.prototype.$Toast.clear()
    let json = res.data
    if (typeof json === 'string') {
        json = JSON.parse(json)
    }
    return json
}, err => {
    Vue.prototype.$Toast($language.request.err500)
    return Promise.reject(err)
})

export function createAPI (url, method, data) {
    let config = {
        method: method,
        url: url,
        data
    }
    if (method.toLocaleLowerCase() === 'get') {
        config.params = data
    }
    return apiConfig(config)
}
